import React, {Component, Fragment} from 'react';
import CheckoutDetail from './checkoutDetail';

class Checkout extends Component{
    render(){
        return(
            <Fragment>
                <div style={{backgroundColor:'#f4f6f9', minHeight: '100vh'}}>
                    <CheckoutDetail />
                </div>
            </Fragment>
        )
    }
}

export default Checkout;